import lineByLineAnimation from './line-by-line-animation';

const addTitleToTimeline = (textBlockElement, timeline, positionNumber) => {
    const onAnimationCompleteCallbacks = [];
    [...textBlockElement.children].forEach((element, index) => {
        const position = index === 0 ? positionNumber : '-=0.15';
        let clearCallBack = null;
        switch (true) {
        case element.classList.contains('heading'):
            clearCallBack = lineByLineAnimation(element, timeline, position);
            break;
        default:
            break;
        }
        if (clearCallBack) onAnimationCompleteCallbacks.push(clearCallBack);
    });
    return onAnimationCompleteCallbacks;
};

export default addTitleToTimeline;
